import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import SimpleInput from 'components/SimpleInput';
import CheckBox from 'components/CheckBox';
import S from 'modal.scss';
import { getPhaseErrors } from '../../../../../../../reducers';
import pdfURL from './coc.jpg';

class ContractorConfirmation extends Resetter(Validator(React.Component)) {
  state = {
    approveTerms: this.props.approveTerms || false,
    contractorName: this.props.contractorName || '',
    errors: {},
  };

  static VALIDATIONS = {
    contractorName: true,
    approveTerms: true,
  }

  contractorConfirmationRef = React.createRef();

  componentDidMount() {
    this.contractorConfirmationRef.current.scrollIntoView(true);
  }

  handleSubmit = () => {
    if (!this.validate()) { return; }
    this.props.updateFormData({
      contractorName: this.state.contractorName,
      approveTerms: this.state.approveTerms,
      tab: 5,
    });
  }

  handlePrevious = () => {
    this.props.updateFormData({
      contractorName: this.state.contractorName,
      approveTerms: this.state.approveTerms,
      tab: 3,
    });
  }

  handleNameChange = (e) => {
    this.setState({ contractorName: e.target.value });
  }

  handleApproveTermsChange = () => {
    this.setState({ approveTerms: !this.state.approveTerms });
  };

  render() {
    const { contractorName, errors } = this.state;

    return (
      <div ref={this.contractorConfirmationRef}>
        <h6>Part 4 - Contractor Confirmation</h6>
        <CheckBox
          label="Approve Terms *"
          required
          text="I confirm I've read and approve the linked document and its terms."
          errors={errors.approveTerms} onChange={this.handleApproveTermsChange}
          checked={this.state.approveTerms}
        />
        <a href={pdfURL} target="_blank" rel="noopener noreferrer" className={S.cocLink}>Link to COC Agreement</a>
        <SimpleInput
          label="Print Contractor's Name *"
          required
          text={contractorName}
          errors={errors.contractorName}
          onChange={this.handleNameChange}
        />
        <Button label="Next" flat inverse ripple className={S.submit} onClick={this.handleSubmit} />
        <Button label="Previous" flat inverse ripple className={S.submit} onClick={this.handlePrevious} />
      </div>
    );
  }
}

ContractorConfirmation.propTypes = {
  errors: PropTypes.shape({
    contractorName: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {
})(ContractorConfirmation);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/cocSignature/contractor_confirmation.jsx